import React from 'react';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { useNewBookingStore } from '../../../domain/booking/stores/useNewBookingsStore';
import { ConfirmationNewBooking } from '../../booking-steps/confirmation/ConfirmationNewBooking';
import { Confirmation } from '../../booking-steps/confirmation';
import { BookingPageLayout } from '../shared/BookingPageLayout';

export const NewBookingConfirmationPage = () => {
	const { t } = useTranslation();

	const { booking } = useNewBookingStore();

	return (
		<BookingPageLayout title={t('web_parking_confirmation_header')}>
			<Confirmation>
				<ConfirmationNewBooking booking={booking} />
			</Confirmation>
		</BookingPageLayout>
	);
};
